const initialState = {
    selectedDestination: null,
    // other state properties...
  };
  
  const selectedDestination = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_SELECTED_DESTINATION':
        return {
          ...state,
          selectedDestination: action.payload,
        };
      // handle other actions...
      default:
        return state;
    }
  };
  
  export default selectedDestination;
  